import React from 'react';
import Header from '../Header';
import NextEvent from './NextEvent';
import FutureEvents, { EventInterface } from './FutureEvents';
import PastEvents from './PastEvents';

function Events() {
    const events: EventInterface[] = [
        // past event format
        // { name: "GAME NIGHT 1", description: "", timeEnd: "2026-06-05T15:00:00", timeText: "Sun, June 5, 1pm-3pm PST", location: "some location", link: ""},
        
        { name: "SMUT BOOK NIGHT", description: "", timeEnd: "2026-07-18T19:00:00", timeText: "Sat, June 18, 6pm-7pm PST", location: "We Be Book'N Bookstore, Monroe WA", link: ""},
        { name: "JUSTLY GAME NIGHT", description: "", timeEnd: "2026-07-11T18:00:00", timeText: "Sat, July 11, 5pm-6pm PST", location: "Little Oddfellows Cafe, Seattle WA", link: ""},
        { name: "JUSTLY AND SMOOTHIES", description: "", timeEnd: "2026-07-05T18:00:00", timeText: "Sun, July 5, 3pm-6pm PST", location: "Emerald City Smoothie, Seattle WA", link: ""},


        // future event format
        // { image: "coffeeshop.png", name: "GAME NIGHT 1", description: "some description", timeEnd: "2026-06-05T15:00:00", timeText: "Sun, June 5, 1pm-3pm PST", location: "some location", link: "event link"},
    ];

    const now = new Date();

    const futureEvents = events.filter(
        event => new Date(event.timeEnd) > now
    );

    const pastEvents = events.filter(
        event => new Date(event.timeEnd) < now
    );

    const nextEvent = futureEvents.length > 0 ? futureEvents[0]: undefined;

    return (
        <div className="eventsWrapper">
            <Header />
            {nextEvent && <NextEvent nextEvent={nextEvent} />}
            {futureEvents.length > 0 && <FutureEvents futureEvents={futureEvents} />}
            {pastEvents.length > 0 && <PastEvents pastEvents={pastEvents} />}
        </div>
    )
}

export default Events;